<template>
  <div class="page-container">
    <div class="page-title-container d-flex align-items-center justify-content-between">
      <h1 class="page-title mb-0">Importar viajes de Despegar</h1>
      <b-button :to="{ name: 'imports-despegar-upload' }" variant="none" class="button button-primary">
        <i class="ri-upload-2-line"></i> Cargar Excel
      </b-button>
    </div>

    <div class="table-container">
      <div class="table-header d-flex justify-content-between align-items-center">
        <h3 class="m-0">Importaciones anteriores</h3>
        <button type="button" class="button-tooltip text-dark font-weight-bold" v-b-tooltip.hover
          title="Recargar" @click="loadLogs">
          <i class="ri-loop-right-line"></i>
        </button>
      </div>

      <div class="table-responsive mb-0 table-min-height">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th class="pl-4 text-left">Fecha / Hora</th>
              <th class="text-left">Usuario</th>
              <th class="text-left">Archivo</th>
              <th class="text-center">Total Excel</th>
              <th class="text-center">Importados</th>
              <th class="text-center">Duplicados</th>
              <th class="text-center">Errores</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="l in logs" :key="l.id">
              <td class="pl-4">{{ formatDateTime(l.created_at) }}</td>
              <td>{{ l.user_email }}</td>
              <td>
                <div>{{ l.file_name || '—' }}</div>
                <div class="text-muted small">{{ l.source }}</div>
              </td>
              <td class="text-center">{{ l.total_filas }}</td>
              <td class="text-center font-weight-bold">{{ l.creadas }}</td>
              <td class="text-center">{{ l.duplicadas }}</td>
              <td class="text-center" :class="{ 'text-danger': l.errores > 0 }">{{ l.errores }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          v-if="logs.length"
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
        />
        <div class="table-no-results" v-else>
          <p class="m-0 px-3">Todavía no se importó ningún archivo.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert, Pagination } from "wize-admin";

import { ImportService } from "@/core/services";

// Historial de importaciones (DEF-ADM-022). La carga del archivo vive en su
// propia pantalla, para no mezclar consultar con importar.
export default {
  name: "DespegarHistory",
  components: { Pagination },
  data() {
    return {
      logs: [],
      total: 0,
      page: 1,
      pageSize: 100, // mismo valor inicial que el selector del componente pagination
    };
  },
  computed: {
    pages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize));
    },
  },
  methods: {
    // "2026-09-22 15:40:12" → "22/09/2026 15:40"
    formatDateTime(value) {
      if (!value) return "—";
      const [date, time] = value.split(" ");
      const [y, m, d] = (date || "").split("-");
      return `${d}/${m}/${y} ${(time || "").slice(0, 5)}`.trim();
    },
    async loadLogs() {
      try {
        await this.$store.dispatch("app/loading", true);
        const res = await ImportService.logs({ page: this.page - 1, size: this.pageSize });
        this.logs = res.payload.items || [];
        this.total = res.payload.metadata ? res.payload.metadata.totalElements : 0;
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors ? ex.errors.message : "No se pudo cargar el historial de importaciones");
        this.logs = [];
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    changePage(p) {
      this.page = p;
      this.loadLogs();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.page = 1;
      this.loadLogs();
    },
  },
  async mounted() {
    await this.loadLogs();
  },
};
</script>

<style lang="stylus" scoped></style>
